import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { LoginLayoutComponent } from './layouts/login/login-layout.component';
import { MainLayoutComponent } from './layouts/main/main-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';

import { OnlyMobileGuard } from './core/guards/only-mobile.guard';
import { RedirectToMobilePageGuard } from './core/guards/redirect-to-mobile-page.guard';
import { MobileLayoutComponent } from './layouts/mobile/mobile-layout.component';
import { prefetchShipmentsMap } from './modules/shipments/shared/prefetch-shipments-map.guard';

const routes: Route[] = [
  {
    path: '', redirectTo: 'shipments', pathMatch: 'full'
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'account',
        loadChildren: () =>
          import('./modules/account/account.module').then(
            (m) => m.AccountModule
          ),
        canActivate: [],
      }
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'shipments',
        loadChildren: () =>
          import('./modules/shipments/desktop/shipments.module').then(
            (m) => m.ShipmentsModule
          ),
        canMatch: [prefetchShipmentsMap],
        canActivate: [AuthGuard, RedirectToMobilePageGuard]
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./modules/admin/admin.module').then(
            (m) => m.AdminModule
          ),
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'not-found',
        loadComponent: () =>
          import('./modules/not-found/not-found.component').then(
            (m) => m.NotFoundComponent
          ),
        // Redirect mobile users to /mobile/not-found so the page renders inside
        // the mobile layout (mobile header) instead of the desktop sidebar.
        canActivate: [AuthGuard, RedirectToMobilePageGuard]
      },
    ]
  },
  {
    path: 'mobile',
    component: MobileLayoutComponent,
    children: [
      { path: '', redirectTo: 'shipments', pathMatch: 'full' },
      {
        path: 'shipments',
        loadChildren: () =>
          import('./modules/shipments/mobile/mobile-shipments.module').then(
            (m) => m.MobileShipmentsModule
          ),
        canMatch: [prefetchShipmentsMap],
        canActivate: [AuthGuard, OnlyMobileGuard],
      },
      {
        path: 'not-found',
        loadComponent: () =>
          import('./modules/not-found/not-found.component').then(
            (m) => m.NotFoundComponent
          ),
        canActivate: [AuthGuard, OnlyMobileGuard],
      }
    ],
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
